module.exports = __webpack_public_path__ + "img/photo-camera.63d20d83.svg";